module.exports = __webpack_public_path__ + "fonts/SVN-Mabella.b05aadfd.woff";